export const DASHBOARD_CARD_HEIGHT = 550;
